import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LogIn as LogInIcon } from "lucide-react";

import { Button } from "@acme/ui/button";

export function UnauthenticatedState() {
  const pathname = usePathname();

  return (
    <div className="mx-auto flex h-full w-[80%] flex-col items-center justify-center gap-3 px-2 text-center">
      <Image src="/images/login.png" width={250} height={88} alt="Login" />
      <h3 className="text-base font-bold">Run on GitHub Repos</h3>
      <p className="text-muted-foreground text-sm">
        Instantly dry-run code queries and transformations to gain insights and
        uncover improvements.
      </p>
      <Button variant="outline" className="flex items-center gap-2" asChild>
        <Link href={`/login?redirect=${pathname}`}>
          <LogInIcon className="size-4" />
          Sign in
        </Link>
      </Button>
    </div>
  );
}
